module.exports = __webpack_public_path__ + "img/contact-banner-old.48d1c534.jpg";